@if (therapeut$ | async; as therapeut) {
  <zah-upsert-therapeut
    [therapeut]="therapeut"
    okLabel="Bewaar"
    (cancelClicked)="onCancelClicked()"
    (okClicked)="onEditClicked($event)">
  </zah-upsert-therapeut>
}
